export default {
  name: 'reports',
  path: 'reports',
  component: () => import(/* webpackChunkName: "reports" */ '@/views/report/reports/index'),
};
